export const formatToNaira = ($amount: number) => Number($amount).toLocaleString("en-NG", { style: "currency", currency: "NGN" });
